module.exports = __webpack_public_path__ + "babc01c7d707cf9975373141b21126ef.MP3";